import type { ComputedRef } from 'vue'

interface MarketOutcome {
  select_numbers?: boolean
  pick?: number | string
}

interface MarketData {
  outcomes?: MarketOutcome[]
}

function collectPickCountsFromMarket(market: MarketData | null | undefined): number[] {
  if (!market?.outcomes?.length) {
    return []
  }

  const picks: number[] = []

  market.outcomes.forEach((outcome) => {
    if (!outcome.select_numbers) return
    const pick = Number(outcome.pick) || 0
    if (pick > 0) picks.push(pick)
  })

  return [...new Set(picks)].sort((a, b) => a - b)
}

export function getAvailablePickCounts(
  selectedMainMarketData: MarketData | null | undefined,
  isBonusOnlyMarket: boolean,
  actualBalls: number
): number[] {
  if (isBonusOnlyMarket) {
    return [1]
  }

  const uniquePicks = collectPickCountsFromMarket(selectedMainMarketData)
  return uniquePicks.length ? uniquePicks : [actualBalls]
}

export function resolveDefaultPickCount(
  availablePickCounts: ComputedRef<number[]> | number[],
  actualBalls: number
): number {
  const counts = Array.isArray(availablePickCounts) ? availablePickCounts : availablePickCounts.value
  if (!counts.length) {
    return actualBalls
  }

  if (counts.includes(actualBalls)) {
    return actualBalls
  }

  return counts[0]
}

export function clampToAvailablePickCount(
  count: number,
  availablePickCounts: number[]
): number {
  if (!availablePickCounts.length) {
    return count
  }

  if (availablePickCounts.includes(count)) {
    return count
  }

  const validAtOrBelow = availablePickCounts.filter((option) => option <= count)
  if (validAtOrBelow.length) {
    return Math.max(...validAtOrBelow)
  }

  return availablePickCounts[0]
}
